import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["show", "searchable", "autoAlign", "autoFocusSearch", "popoverWidth", "triggerId", "children", "emptyContent", "emptyRender", "onSearchChange", "searchPlaceholder", "loading", "renderLoading", "renderFooter"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @file SelectPopoverPanel
 */
import { useSelectPopover } from '@tencent/glue-react-select';
import { usePopperInstance } from '@tencent/glue-react-popper';
import React, { useEffect, useRef } from 'react';
import { Input } from '../Input';
import { ViewSelectPopover } from '../../views/ViewSelectPopover';
export function SelectPopover(props) {
  var show = props.show,
      _props$searchable = props.searchable,
      searchable = _props$searchable === void 0 ? false : _props$searchable,
      _props$autoAlign = props.autoAlign,
      autoAlign = _props$autoAlign === void 0 ? true : _props$autoAlign,
      autoFocusSearch = props.autoFocusSearch,
      _props$popoverWidth = props.popoverWidth,
      popoverWidth = _props$popoverWidth === void 0 ? 110 : _props$popoverWidth,
      triggerId = props.triggerId,
      children = props.children,
      emptyContent = props.emptyContent,
      emptyRender = props.emptyRender,
      onSearchChange = props.onSearchChange,
      _props$searchPlacehol = props.searchPlaceholder,
      searchPlaceholder = _props$searchPlacehol === void 0 ? '搜索关键词' : _props$searchPlacehol,
      loading = props.loading,
      renderLoading = props.renderLoading,
      renderFooter = props.renderFooter,
      extra = _objectWithoutProperties(props, _excluded);

  delete extra.arrowRef;
  delete extra.placement;
  delete extra.arrowDirection;
  delete extra.showArrow;
  delete extra.arrowStyle;
  var panelRef = useRef(null);
  var inputRef = useRef(null);

  var _useSelectPopover = useSelectPopover(panelRef),
      query = _useSelectPopover.query,
      isEmpty = _useSelectPopover.isEmpty,
      setQuery = _useSelectPopover.setQuery;

  var onValueChange = function onValueChange(query) {
    onSearchChange === null || onSearchChange === void 0 ? void 0 : onSearchChange(query);
    setQuery(query);
  };

  var popper = usePopperInstance();
  var activeTrigger = popper.getTrigger(triggerId);
  var panelWidth = autoAlign && activeTrigger ? activeTrigger.getRect().width : popoverWidth;
  useEffect(function () {
    var _a, _b;

    if (autoFocusSearch) {
      (_b = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 ? void 0 : _b.call(_a);
    }
  }, [show, autoFocusSearch]);
  var search = React.createElement(Input, {
    inputRef: inputRef,
    value: query,
    onValueChange: onValueChange,
    placeholder: searchPlaceholder
  });

  var renderEmpty = function renderEmpty() {
    if (emptyRender) {
      return typeof emptyRender === 'function' ? emptyRender(!!query) : emptyRender;
    }

    var content = emptyContent ? typeof emptyContent === 'function' ? emptyContent(!!query) : emptyContent : '暂无数据'; // todo

    return React.createElement("div", null, content);
  };

  return React.createElement(ViewSelectPopover, _objectSpread(_objectSpread({}, extra), {}, {
    elRef: panelRef,
    searchable: searchable,
    search: search,
    popoverWidth: panelWidth,
    hasFooter: Boolean(renderFooter),
    footer: renderFooter === null || renderFooter === void 0 ? void 0 : renderFooter(),
    isLoading: loading,
    loading: renderLoading === null || renderLoading === void 0 ? void 0 : renderLoading()
  }), isEmpty && !loading && renderEmpty(), children);
}